// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"91":"oz-upgradeable","244":"deploy-source-mode","324":"stargate-contracts","772":"vebetterdao-contracts","902":"oz-contracts"}[chunkId] || chunkId) + "-legacy." + {"91":"8eb51ef1","141":"222b2b09","244":"df114eb0","324":"c0046652","772":"84545bfb","902":"02d7d95f"}[chunkId] + ".js";
};